const translations = {
  "en": {
    "Rebind": "Rebind",
    "The binding has expired. Last Update time: {time}": "The binding has expired. Last Update time: {time}"
  },
  "zh-tw": {
    "Rebind": "重新綁定",
    "The binding has expired. Last Update time: {time}": "綁定已過期。最後更新時間：{time}"
  }
};

export default translations;
